import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class Message {
  static async send (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('messages/send', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static templates (params) {
    return http.post('messages/templates', params)
  }
}

export default Message
